module.exports = "/_next/static/images/nj-2x-7d0f5038c94a66cbc39ae935a55f8eda.png.webp";